import { useStaticQuery, graphql } from 'gatsby';

export const useDevices = () => {
  const { allMdx } = useStaticQuery(graphql`
    query devicesQuery {
      allMdx(filter: { fields: { source: { eq: "devices" } } }) {
        nodes {
          frontmatter {
            title
            anchor
            description
            images {
              childImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: NONE
                  transformOptions: { fit: CONTAIN }
                )
              }
              publicURL
            }
          }
        }
      }
    }
  `);

  return (
    allMdx?.nodes.map((device) => ({
      ...device.frontmatter
    })) || []
  );
};
